import { render, staticRenderFns } from "./Organism.vue?vue&type=template&id=68b79fe8&scoped=true"
import script from "./Organism.vue?vue&type=script&lang=js"
export * from "./Organism.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68b79fe8",
  null
  
)

export default component.exports